import { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon, PhoneIcon, WhatsAppIcon, ChevronDownIcon, StarIcon } from './Icons';
import BookingForm from './BookingForm';
import FloatingCTA from './FloatingCTA';

export default function ConditionPage({ data }) {
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <div style={{ background:'var(--cream)', minHeight:'100vh' }}>

      {/* ── Minimal Header ── */}
      <header style={{
        position:'fixed', top:0, left:0, right:0, zIndex:100,
        background:'rgba(255,255,255,0.97)', backdropFilter:'blur(12px)',
        borderBottom:'1px solid var(--cream-dark)',
        height:'68px', display:'flex', alignItems:'center', padding:'0 24px',
        justifyContent:'space-between',
      }}>
        <Link to="/" style={{ display:'flex', alignItems:'center', gap:'10px' }}>
          <div style={{
            width:'36px', height:'36px', background:'var(--teal)',
            borderRadius:'8px', display:'flex', alignItems:'center',
            justifyContent:'center', color:'white', fontWeight:'800', fontSize:'17px',
            fontFamily:'Playfair Display, serif',
          }}>M</div>
          <div>
            <div style={{ fontFamily:'Playfair Display,serif', fontWeight:'700', fontSize:'16px', color:'var(--navy)', lineHeight:1.1 }}>MotionCare</div>
            <div style={{ fontSize:'10px', color:'var(--teal)', fontWeight:'600', letterSpacing:'1px', textTransform:'uppercase' }}>Physio</div>
          </div>
        </Link>
        <div style={{ display:'flex', alignItems:'center', gap:'12px' }}>
          <a href="tel:+97100000000" style={{ display:'flex', alignItems:'center', gap:'6px', fontSize:'14px', fontWeight:'600', color:'var(--navy)' }} className="hide-mobile">
            <PhoneIcon size={14} color="var(--teal)" />
            +971 XX XXX XXXX
          </a>
          <a href="https://wa.me/97100000000" target="_blank" rel="noopener noreferrer"
            style={{ display:'flex', alignItems:'center', gap:'6px', background:'#25D366', color:'white', padding:'8px 16px', borderRadius:'50px', fontSize:'13px', fontWeight:'600' }}
            className="hide-mobile"
          >
            <WhatsAppIcon size={13} color="white" /> WhatsApp
          </a>
        </div>
      </header>

      {/* ── HERO ── */}
      <section style={{ position:'relative', minHeight:'90vh', display:'flex', alignItems:'center', paddingTop:'68px' }}>
        <div
          className="hero-photo"
          style={{ backgroundImage:`url('${data.photo}')` }}
        />
        <div className="hero-overlay" />
        <div className="container" style={{ position:'relative', zIndex:1, padding:'72px 24px 80px' }}>
          <div style={{ maxWidth:'620px' }}>
            <div className="section-tag-white">{data.tag}</div>
            <h1 style={{ fontSize:'clamp(34px,5.5vw,58px)', color:'white', marginBottom:'18px', lineHeight:'1.15' }}>
              {data.headline}
            </h1>
            <p style={{ fontSize:'18px', color:'rgba(255,255,255,0.82)', marginBottom:'36px', maxWidth:'520px', lineHeight:'1.75' }}>
              {data.subheadline}
            </p>
            {/* TWO CTAs ONLY */}
            <div style={{ display:'flex', gap:'14px', flexWrap:'wrap' }}>
              <a href="#booking" className="btn-primary" style={{ fontSize:'16px', padding:'15px 32px' }}>
                Request a Home Visit
              </a>
              <a
                href="https://wa.me/97100000000?text=Hi%2C%20I%20need%20help%20with%20my%20condition"
                target="_blank" rel="noopener noreferrer"
                className="btn-outline"
                style={{ fontSize:'16px', padding:'15px 32px' }}
              >
                <WhatsAppIcon size={18} color="white" />
                WhatsApp Us
              </a>
            </div>
            {/* Trust row */}
            <div style={{ display:'flex', gap:'20px', marginTop:'40px', flexWrap:'wrap' }}>
              {['DHA Licensed Therapists','Sessions from AED 250','Female Therapists Available'].map(t => (
                <div key={t} style={{ display:'flex', alignItems:'center', gap:'6px', color:'rgba(255,255,255,0.75)', fontSize:'13px', fontWeight:'500' }}>
                  <CheckIcon size={14} color="var(--teal)" />
                  {t}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── PAIN POINTS ── */}
      <section style={{ background:'var(--white)', padding:'72px 24px' }}>
        <div className="container">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'60px', alignItems:'center' }}>
            <div>
              <div className="section-tag">Does this sound familiar?</div>
              <h2 style={{ fontSize:'36px', marginBottom:'28px' }}>
                You should not have to live with this.
              </h2>
              <div style={{ display:'grid', gap:'14px' }}>
                {data.painPoints.map((pt, i) => (
                  <div key={i} style={{ display:'flex', gap:'12px', alignItems:'flex-start' }}>
                    <div style={{
                      width:'22px', height:'22px', borderRadius:'50%',
                      background:'var(--teal-light)', display:'flex',
                      alignItems:'center', justifyContent:'center', flexShrink:0, marginTop:'2px',
                    }}>
                      <CheckIcon size={12} color="var(--teal-dark)" />
                    </div>
                    <span style={{ fontSize:'15px', color:'var(--text)', lineHeight:'1.6' }}>{pt}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={{
              background:'var(--cream)', borderRadius:'var(--radius-lg)',
              padding:'36px', border:'1px solid var(--cream-dark)',
            }}>
              <div className="section-tag">How we help</div>
              <p style={{ fontSize:'16px', color:'var(--text)', lineHeight:'1.8' }}>
                {data.intro}
              </p>
              <div style={{ display:'flex', gap:'16px', marginTop:'28px' }}>
                <div style={{ textAlign:'center' }}>
                  <div style={{ fontSize:'28px', fontWeight:'700', color:'var(--teal)', fontFamily:'Playfair Display,serif' }}>DHA</div>
                  <div style={{ fontSize:'12px', color:'var(--text-light)', fontWeight:'500' }}>Licensed</div>
                </div>
                <div style={{ width:'1px', background:'var(--cream-dark)' }} />
                <div style={{ textAlign:'center' }}>
                  <div style={{ fontSize:'28px', fontWeight:'700', color:'var(--teal)', fontFamily:'Playfair Display,serif' }}>1:1</div>
                  <div style={{ fontSize:'12px', color:'var(--text-light)', fontWeight:'500' }}>Dedicated care</div>
                </div>
                <div style={{ width:'1px', background:'var(--cream-dark)' }} />
                <div style={{ textAlign:'center' }}>
                  <div style={{ fontSize:'28px', fontWeight:'700', color:'var(--teal)', fontFamily:'Playfair Display,serif' }}>Home</div>
                  <div style={{ fontSize:'12px', color:'var(--text-light)', fontWeight:'500' }}>We come to you</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── TECHNIQUES ── */}
      <section style={{ background:'var(--cream)', padding:'72px 24px' }}>
        <div className="container">
          <div style={{ textAlign:'center', marginBottom:'48px' }}>
            <div className="section-tag">How we treat it</div>
            <h2 style={{ fontSize:'38px' }}>Techniques we use</h2>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))', gap:'20px' }}>
            {data.techniques.map((t, i) => (
              <div key={i} style={{
                background:'white', padding:'28px 24px',
                borderRadius:'var(--radius-lg)', border:'1px solid var(--cream-dark)',
              }}>
                <div style={{ display:'flex', alignItems:'flex-start', gap:'14px' }}>
                  <div style={{
                    width:'36px', height:'36px', background:'var(--teal-light)',
                    borderRadius:'8px', display:'flex', alignItems:'center',
                    justifyContent:'center', flexShrink:0,
                  }}>
                    <CheckIcon size={16} color="var(--teal-dark)" />
                  </div>
                  <div>
                    <div style={{ fontWeight:'600', fontSize:'15px', marginBottom:'6px' }}>{t.name}</div>
                    <div style={{ fontSize:'14px', color:'var(--text-light)', lineHeight:'1.65' }}>{t.desc}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Equipment */}
          <div style={{ marginTop:'40px', background:'var(--navy)', padding:'36px', borderRadius:'var(--radius-lg)' }}>
            <h3 style={{ color:'white', fontSize:'20px', marginBottom:'20px', fontFamily:'DM Sans,sans-serif', fontWeight:'600' }}>
              Equipment we bring to your home
            </h3>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:'12px' }}>
              {data.equipment.map((eq, i) => (
                <div key={i} style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                  <CheckIcon size={14} color="var(--teal)" />
                  <span style={{ color:'rgba(255,255,255,0.8)', fontSize:'14px' }}>{eq}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── RECOVERY TIMELINE ── */}
      <section style={{ background:'var(--white)', padding:'72px 24px' }}>
        <div className="container">
          <div style={{ textAlign:'center', marginBottom:'48px' }}>
            <div className="section-tag">What to expect</div>
            <h2 style={{ fontSize:'38px' }}>Your recovery journey</h2>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))', gap:'2px' }}>
            {data.timeline.map((t, i) => (
              <div key={i} style={{ position:'relative', padding:'28px 24px', background: i % 2 === 0 ? 'var(--cream)' : 'var(--white)', borderRadius:'var(--radius)' }}>
                <div style={{ fontSize:'12px', fontWeight:'700', color:'var(--teal)', textTransform:'uppercase', letterSpacing:'0.8px', marginBottom:'8px' }}>
                  {t.session}
                </div>
                <div style={{ fontWeight:'600', fontSize:'15px', marginBottom:'8px', color:'var(--navy)' }}>
                  {t.label}
                </div>
                <div style={{ fontSize:'14px', color:'var(--text-light)', lineHeight:'1.65' }}>
                  {t.desc}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── BOOKING FORM ── */}
      <section id="booking" style={{ background:'var(--navy)', padding:'72px 24px' }}>
        <div className="container">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'60px', alignItems:'start' }}>
            <div>
              <div className="section-tag-white">{data.tag}</div>
              <h2 style={{ fontSize:'38px', color:'white', marginBottom:'16px' }}>
                Request your home visit
              </h2>
              <p style={{ color:'rgba(255,255,255,0.7)', fontSize:'16px', lineHeight:'1.75', marginBottom:'32px' }}>
                Fill in your details and we will call you back to confirm your appointment and match you with the right therapist.
              </p>
              <div style={{ display:'grid', gap:'16px' }}>
                {[
                  'DHA-licensed therapists only',
                  'Female therapists available on request',
                  'Sessions from AED 250',
                  'No payment needed to request a visit',
                ].map((pt, i) => (
                  <div key={i} style={{ display:'flex', gap:'10px', alignItems:'center' }}>
                    <CheckIcon size={14} color="var(--teal)" />
                    <span style={{ color:'rgba(255,255,255,0.75)', fontSize:'14px' }}>{pt}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={{ background:'rgba(255,255,255,0.06)', padding:'36px', borderRadius:'var(--radius-lg)', border:'1px solid rgba(255,255,255,0.12)' }}>
              <BookingForm preCondition={data.tag.split(' ')[0] + ' ' + (data.tag.split(' ')[1] || '')} darkBg={true} />
            </div>
          </div>
        </div>
      </section>

      {/* ── FAQ ── */}
      <section style={{ background:'var(--cream)', padding:'72px 24px' }}>
        <div className="container" style={{ maxWidth:'720px' }}>
          <div style={{ textAlign:'center', marginBottom:'48px' }}>
            <div className="section-tag">FAQ</div>
            <h2 style={{ fontSize:'38px' }}>Common questions</h2>
          </div>
          <div style={{ display:'grid', gap:'10px' }}>
            {data.faqs.map((faq, i) => (
              <div key={i} style={{ background:'white', borderRadius:'var(--radius)', border:'1px solid var(--cream-dark)', overflow:'hidden' }}>
                <button
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                  style={{
                    width:'100%', padding:'20px 24px',
                    background:'transparent', textAlign:'left',
                    display:'flex', justifyContent:'space-between', alignItems:'center', gap:'16px',
                  }}
                >
                  <span style={{ fontWeight:'600', fontSize:'15px', color:'var(--navy)' }}>{faq.q}</span>
                  <div style={{ transform: openFaq === i ? 'rotate(180deg)' : 'rotate(0)', transition:'transform 0.2s', flexShrink:0 }}>
                    <ChevronDownIcon size={18} color="var(--teal)" />
                  </div>
                </button>
                {openFaq === i && (
                  <div style={{ padding:'0 24px 20px', fontSize:'15px', color:'var(--text-light)', lineHeight:'1.75', borderTop:'1px solid var(--cream-dark)' }}>
                    <p style={{ paddingTop:'16px' }}>{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── MINIMAL FOOTER ── */}
      <footer style={{ background:'var(--navy)', padding:'32px 24px', textAlign:'center' }}>
        <div style={{ color:'rgba(255,255,255,0.5)', fontSize:'13px', marginBottom:'12px' }}>
          © 2026 MotionCare Physio · DHA Licensed · Dubai
        </div>
        <div style={{ display:'flex', justifyContent:'center', gap:'20px', fontSize:'13px' }}>
          <Link to="/" style={{ color:'rgba(255,255,255,0.5)' }}>Home</Link>
          <Link to="/back-pain" style={{ color:'rgba(255,255,255,0.5)' }}>Back Pain</Link>
          <Link to="/sports-injury" style={{ color:'rgba(255,255,255,0.5)' }}>Sports Injury</Link>
          <Link to="/post-surgery" style={{ color:'rgba(255,255,255,0.5)' }}>Post-Surgery</Link>
          <Link to="/elderly-care" style={{ color:'rgba(255,255,255,0.5)' }}>Elderly Care</Link>
        </div>
      </footer>

      <FloatingCTA />
    </div>
  );
}
